<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th v-for="column in columns" :key="column">{{ column }}</th>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>
            <img style="width: 25%; height: 25%" :src="item.artwork_path" />
          </td>
          <td>
            <span>{{ item.reference_id }}</span>
          </td>
          <td>
            <span>{{ item.product_name }}</span>
          </td>
          <td>
            <span>{{ item.skus }}</span>
          </td>
          <td>
            <span>{{ item.qty }}</span>
          </td>
          <td>
            <b-button id="show-btn" @click="showModal(item)">Reprint</b-button>
          </td>
          <!-- <slot :row="item">
          <td v-for="(column, index) in columns" :key="index">
            {{ itemValue(item, column) }}
          </td>
        </slot> -->
        </tr>
      </tbody>
    </table>
    <b-modal ref="my-modal" hide-footer title="How Many Reprints?">
      <div class="d-block text-center">
        <!-- <h5>Quantity</h5> -->
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-12">
              <fg-input type="number" label="Quantity:" v-model="quantity">
              </fg-input>
            </div>
          </div>

          <div class="row"></div>

          <div class="row"></div>

          <div class="row"></div>
          <!-- 
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Notes</label>
              <textarea
                rows="5"
                class="form-control border-input"
                v-model="reprint.notes"
              >
              </textarea>
            </div>
          </div>
        </div> -->
          <div class="clearfix"></div>
          <br />
          <div class="text-center">
            <p-button
              type="info"
              round
              @click.native.prevent="sendOrderToReprint"
            >
              Send Reprint
            </p-button>
          </div>
        </form>
      </div>
      <!-- <b-button class="mt-3" variant="outline-danger" block @click="hideModal"
        >Reprint</b-button
      > -->
    </b-modal>
  </div>
</template>
<script>
import * as reprintOrderService from "../services/reprintOrder.service";
import QuantityModal from "@/components/QuantityModal.vue";
export default {
  name: "paper-table",
  data() {
    return {
      reprintOrders: [],
      isModalVisible: false,
      quantity: "",
    };
  },
  components: {
    QuantityModal,
  },
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    showModal(item) {
      console.log("item: " + JSON.stringify(item));
      this.reprintOrders.push(item);
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    sendOrderToReprint(item) {
      console.log("item:: " + JSON.stringify(this.reprintOrders));
      let data = {
        reprintOrder: this.reprintOrders,
        qty: this.quantity,
      };
      //API to send reprint data
      reprintOrderService.sendOrderToReprint(data).then((response) => {
        console.log("response: " + JSON.stringify(response));
      });
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
  },
};
</script>
<style>
</style>
